<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button [routerLink]="['/inventory/fermenter']">
        <ion-icon name="arrow-back-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button (click)="confirmDelete(item()!)" data-testid="fermenter-detail-delete">
        <ion-icon
          slot="icon-only"
          color="danger"
          name="trash-outline"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      <span>{{ item()?.name }}</span>
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  @if (item() && bar() && units()) {
    <app-fermenter-form
      [item]="item()!"
      [bar]="bar()!"
      [units]="units()!"
      [uid]="userId()"
      [allBeverages]="beverages()"
      [allLocations]="locations()"
      [brewfather]="brewfather()"
      (softUpdateFermenter)="softUpdateFermenter($event)"
    ></app-fermenter-form>
  }
</ion-content>
